import {IdToken, useAuth0} from "@auth0/auth0-react";
import {useMemo} from "react";

export const useKensuAuth = () => {

  const auth = useAuth0();

  // Memoized; if not memoized, any effect that adds a dependency on the user object
  // will refresh every frame because a different user gets returned 
  const localUser = useMemo(() => {
    return {
      isAuthenticated: true,
      isLoading: false,
      user: {
        email: 'me@localhost',
        sub: 'local|012345',
        name: 'local user',
        nickname: 'localla',
      },
      logout: () => {
        window.alert('not implemented for local')
      },
      loginWithRedirect: () => {
      },
      getIdTokenClaims: () => {
        return new Promise<IdToken>((resolve, reject) => {
          resolve({
            __raw: 'local-very-secret-token-9f3e62ca' // same as server's local auth module
          })
        })
      }
    }
  }, [])

  // if (window.location.hostname.startsWith('localhost')) {
  //   return localUser;
  // }

  return auth;
}